import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    radioWell: {
        paddingBottom: 7
    },
    error: {
        marginTop: 5,
        marginBottom: 0
    },
    warning: {
        marginBottom: 10
    },
    // The recipient drawer sets zIndex 99999999, so the modal and its backdrop must outrank it.
    modalBackdrop: {
        zIndex: 100000000
    },
    modal: {
        zIndex: 100000001
    }
};
